import React from 'react'

import { Modal, Button } from '_zari/core'

const PrevisualizarPdfModal = ({ show, handleClose, pdfBlobUrl }) => {
  return (
    <Modal show={show} size='lg'>
      <Modal.Header>
        <Modal.Title>Previsualización PDF</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {pdfBlobUrl ? (
          <iframe src={pdfBlobUrl} title='PDF Preview' style={{ width: '100%', height: '70vh', border: 'none' }} />
        ) : (
          <div>Cargando PDF...</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button outline color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(PrevisualizarPdfModal)
